<div class="main-container">

    <div class="container d-flex justify-content-center">

        <div [formGroup]="mdl_TripSAD" class="row gx-3 gy-1 p-2">

            <!-- نوع متحرک -->
            <div class="col-12 col-md-6 position-relative">

                <div class="w-100" *ngIf="list_MobileType.length">

                    <label> نوع متحرک * </label>

                    <custom-filter
                        [strValue]="returnStrValue('tiMobileType',mdl_TripSAD.get('tiMobileType')?.value,list_MobileType,'strComment')"
                        [strComment]="'strComment'" [stylesArray]="['padding-top: 10px','text-align: center']"
                        [str_Placeholder]="' جستجو کنید ...'" [lst_Main]="list_MobileType"
                        [lst_SearchKey]="['strComment']" [isDisabled]="false"
                        (hideOptions)="mdl_TripSAD.get('tiMobileType')?.setValue($event.tiMobileType)">

                    </custom-filter>

                </div>

            </div>

            <!-- پلاک متحرک -->
            <div class="col-12 col-md-6 position-relative">

                <div class="w-100">

                    <label> پلاک متحرک *</label>

                    <div class="plate-container d-flex">

                        <input class="form-control text-center w-25"
                            (input)="filterNumericInput($event)" inputmode="numeric" maxlength="2" placeholder="- -"
                            formControlName="strVehicleNo_4">

                        <input class="form-control text-center w-25"
                            (input)="filterNumericInput($event)" inputmode="numeric" maxlength="3" placeholder="- - -"
                            formControlName="strVehicleNo_3">

                        <input class="form-control text-center w-25"
                            oninput="this.value=this.value.replace(/[^ء-ی]/g, '')" maxlength="1" placeholder="-"
                            formControlName="strVehicleNo_2">

                        <input class="form-control text-center w-25"
                            (input)="filterNumericInput($event)" inputmode="numeric" maxlength="2" placeholder="- -"
                            formControlName="strVehicleNo_1">

                    </div>

                </div>

            </div>

            <!-- نوع درخواست امداد  -->
            <div class="col-12 col-md-6 position-relative">

                <div class="w-100" *ngIf="list_ReliefType.length">

                    <label> نوع درخواست * </label>

                    <custom-filter
                        [strValue]="returnStrValue('tiReliefRequestType',mdl_TripSAD.get('tiReliefRequestType')?.value,list_ReliefType,'strComment')"
                        [strComment]="'strComment'" [stylesArray]="['padding-top: 10px','text-align: center']"
                        [str_Placeholder]="' جستجو کنید ...'" [lst_Main]="list_ReliefType"
                        [lst_SearchKey]="['strComment']" [isDisabled]="false"
                        (hideOptions)="updateValue($event.tiReliefRequestType)">

                        <!-- (hideOptions)="mdl_TripSAD.get('tiReliefRequestType')?.setValue($event.tiReliefRequestType)"> -->

                    </custom-filter>

                </div>

            </div>

            <!-- علت درخواست امداد -->
            <div *ngIf="!isInput_Disabled" class="col-12 col-md-6 position-relative">

                <div class="w-100" *ngIf="list_Reason.length && !isInput_Disabled">

                    <label> علت درخواست * </label>

                    <custom-filter
                        [strValue]="returnStrValue('tiReason4Request',mdl_TripSAD.get('tiReason4Request')?.value,list_Reason,'strComment')"
                        [strComment]="'strComment'" [stylesArray]="['padding-top: 10px','text-align: center']"
                        [str_Placeholder]="' جستجو کنید ...'" [lst_Main]="list_Reason" [lst_SearchKey]="['strComment']"
                        [isDisabled]="false"
                        (hideOptions)="mdl_TripSAD.get('tiReason4Request')?.setValue($event.tiReason4Request)">

                    </custom-filter>

                </div>

            </div>

            <!-- دلیل توقف -->
            <div class="col-12 col-md-6 position-relative">

                <div class="w-100">

                    <label> دلیل توقف </label>

                    <input class="form-control w-100" formControlName="strReasonStopping"
                        placeholder="دلیل توقف خود را مشخص کنید...">

                </div>

            </div>

            <!-- نوع امدادگر  -->
            <div *ngIf="!isInput_Disabled" class="col-12 col-md-6 position-relative">

                <div class="w-100" *ngIf="list_MobileGroup.length && !isInput_Disabled">

                    <label> نوع امدادگر * </label>

                    <custom-filter
                        [strValue]="returnStrValue('tiMobileGroup',mdl_TripSAD.get('tiMobileGroup')?.value,list_MobileGroup,'strComment')"
                        [strComment]="'strComment'" [stylesArray]="['padding-top: 10px','text-align: center']"
                        [str_Placeholder]="' جستجو کنید ...'" [lst_Main]="list_MobileGroup"
                        [lst_SearchKey]="['strComment']" [isDisabled]="false"
                        (hideOptions)="mdl_TripSAD.get('tiMobileGroup')?.setValue($event.tiMobileGroup)">

                    </custom-filter>

                </div>

            </div>

            <!-- شهر مبداء -->
            <div class="col-12 position-relative">
                <div class="w-100" *ngIf="list_City.length">
                    <label> شهر مبداء * </label>
                    <custom-filter
                        [strValue]="getCityNameById(Info.strCity ?? '', list_City, 'strCityName')"
                        [strComment]="'strCityName'" [stylesArray]="['padding-top: 10px','text-align: center']"
                        [str_Placeholder]="' جستجو کنید ...'" [lst_Main]="list_City" [lst_SearchKey]="['strCityName']"
                        [isDisabled]="false" (hideOptions)="setValue_Filter($event,'strSCity')">
                    </custom-filter>
                </div>
            </div>

            <!-- آدرس مبداء -->
            <div class="position-relative col-12">
                <label class="text-muted"> آدرس مبداء * </label>
                <input class="form-control p-2 input-start" placeholder="آدرس دقیق خود را وارد کنید ..."
                    formControlName="strSAddress">
                <button class="btn btn-warning rounded" (click)="openMap('strSAddress')">
                    <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                </button>
            </div>

            <ng-container *ngIf="mdl_TripSAD.get('fSLon')?.errors?.['required']">
                <small class="text-danger">موقعیت دقیق مبداء را از روی نقشه انتخاب کنید.</small>
            </ng-container>

            <!-- تاریخ -->
            <div class="col-12 col-md-6 position-relative">
                <label class="text-muted"> تاریخ * </label>
                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY-MM-DD'"
                    [dateFormat]="'jYYYY/jMM/jDD'">
                    <input style="background-color: #ffff;" class="form-control text-start" formControlName="strDate"
                        readonly />
                </ng-persian-datepicker>

            </div>

            <!-- ساعت -->
            <div class="col-12 col-md-6 position-relative">

                <label class="text-muted"> ساعت * </label>

                <input formControlName="strTime" required class="form-control text-center" [format]="24"
                    [ngxTimepicker]="picker">

                <ngx-material-timepicker #picker [cancelBtnTmpl]="cancelBtn" [confirmBtnTmpl]="confirmBtn">

                </ngx-material-timepicker>

                <ng-template #cancelBtn>

                    <button class="Btn_timePicker " style="margin-right: 10px;background-color: #ff0000;">لغو</button>

                </ng-template>

                <ng-template #confirmBtn>

                    <button class="Btn_timePicker " style="background-color: #009620;">تایید</button>

                </ng-template>

            </div>

            <!-- شهر مقصد -->
            <div *ngIf="!isInput_Disabled" class="col-12 position-relative">
                <div class="w-100" *ngIf="list_City.length">
                    <label>شهر مقصد</label>
                    <custom-filter
                        [strComment]="'strCityName'" [stylesArray]="['padding-top: 10px','text-align: center']"
                        [str_Placeholder]="' جستجو کنید ...'" [lst_Main]="list_City" [lst_SearchKey]="['strCityName']"
                        [isDisabled]="false" (hideOptions)="setValue_Filter($event,'strDCity')">
                    </custom-filter>
                </div>
            </div>

            <!-- آدرس مقصد -->
            <div *ngIf="!isInput_Disabled" class="position-relative col-12">
                <label class="text-muted"> آدرس مقصد </label>
                <input class="form-control p-2 input-start" placeholder="آدرس دقیق خود را وارد کنید ..."
                    formControlName="strDAddress">
                <button class="btn btn-warning rounded" (click)="openMap('strDAddress')">
                    <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                </button>
            </div>

            <ng-container *ngIf="mdl_TripSAD.get('fDLon')?.errors?.['required']">
                <small class="text-danger">موقعیت دقیق مقصد را از روی نقشه انتخاب کنید.</small>
            </ng-container>

            <!-- مدال نقشه -->
            <app-custom-map *ngIf="showCustom_Map" [strValue]="mdl_Map.get('strAddress')?.value"
                [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]" [isOpenModal]="true"
                (mdl_Submit)="submitMap($event)">

            </app-custom-map>

            <!-- طرح ترافیک -->
            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">

                <input class="form-check-input m-0" type="checkbox" id="bTraffic" formControlName="bTraffic">

                <label class="form-check-label pointer text-muted me-2" for="bTraffic"> طرح ترافیک </label>

            </div>

            <!-- طرح آلودگی -->
            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">

                <input class="form-check-input m-0" type="checkbox" id="bEvenOdd" formControlName="bEvenOdd">

                <label class="form-check-label pointer text-muted me-2" for="bEvenOdd"> طرح آلودگی </label>

            </div>

            <!-- شرایط آب وهوایی ویژه -->
            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">

                <input class="form-check-input m-0" type="checkbox" id="bBadWeather" formControlName="bBadWeather">

                <label class="form-check-label pointer text-muted me-2" for="bBadWeather"> شرایط آب وهوایی ویژه </label>

            </div>

            <!-- منطقه کوهستانی -->
            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2 mt-2">

                <input class="form-check-input m-0" type="checkbox" id="bMountainous" formControlName="bMountainous">

                <label class="form-check-label pointer text-muted me-2" for="bMountainous"> منطقه کوهستانی </label>

            </div>

            <!-- توضیحات -->
            <div class="col-12 position-relative mt-2">

                <div class="w-100">

                    <textarea class="form-control w-100" formControlName="strComment"
                        [placeholder]="isInput_Disabled ? '* توضیحات خود را وارد کنید ...' : 'توضیحات خود را وارد کنید ..' ">

                    </textarea>

                </div>

            </div>

            <!-- ذخیره -->
            <div class="col-12 mt-3">
                <button class="btn btn-success" (click)="submitRequest()">
                    ثبت درخواست
                </button>
            </div>

        </div>

    </div>

</div>

<!-- ثبت نظر -->

<div class="modal fade" id="Voting_Modal" tabindex="4" role="dialog">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">

                <h2 class="modal-title m-0"> نظرسنجی </h2>

                <button type="button" class="btn-close p-0 m-0" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>
            <div class="modal-body px-md-4 px-2">

                <h3 style="line-height: 30px;"> لطفا نظر خود را در خصوص آخرین سفرتان از

                    <span class="fw-bold"> {{ mdl_Voting.get('strSCityName')?.value }} </span>

                    به <span class="fw-bold"> {{ mdl_Voting.get('strDCityName')?.value }} </span>

                    در تاریخ <span class="fw-bold"> {{ mdl_Voting.get('strDate')?.value | faNum }} </span>

                    بفرمایید.

                    <br>

                    این نظر در بخش نظرات امدادران به سایر کاربران نمایش داده می شود.

                </h3>

                <div [formGroup]="mdl_Voting">

                    <span class="text-large">

                        میزان رضایت خود از سفر را وارد نمایید

                    </span>

                    <div class="my-3">

                        <star-rating [starType]="'svg'" [rating]="0"
                            (ratingChange)="mdl_Voting.get('iDriverPoints')?.setValue($event)">

                        </star-rating>

                    </div>

                    <ng-container *ngIf="mdl_Voting.get('iDriverPoints')?.value != ''">

                        <div class="p-1">

                            <textarea class="w-100 form-control" style="height: 100px;"
                                placeholder="نظر خود را در رابطه با این سفر جهت نمایش در بخش نظرات امدادران بفرمایید."
                                formControlName="strPassengerOpinion">

                            </textarea>

                        </div>

                    </ng-container>

                </div>

            </div>
            <div dir="ltr" class="modal-footer">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">

                    بستن

                </button>

                <button class="btn btn-success px-3 pointer" (click)="submitVote()">

                    &nbsp; ثبت &nbsp;

                </button>

            </div>
        </div>
    </div>
</div>